import React from 'react';
import { type PreferredTransportType } from '../../types/proposalBundles';

type Props = {
  preferredType: PreferredTransportType | null;
};

export const TransportCategoryIcon = ({ preferredType }: Props) => {
  if (preferredType === 'rail') {
    return <img src="/images/train.png" alt="train" style={{ width: '16px', height: '16px' }} />;
  }

  return <img src="/images/plane.png" alt="flight" style={{ width: '16px', height: '16px' }} />;
};
